import { ELEM_TYPES } from '../lib/constants/ElementTypes'

export const LIST_BASED_FIELDS = [
  ELEM_TYPES.RADIO,
  ELEM_TYPES.SELECT,
  ELEM_TYPES.BUTTONGROUP,
  ELEM_TYPES.MULTISELECT,
  ELEM_TYPES.CES,
]
